import { Component, OnInit } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import {FormsModule} from '@angular/forms';

import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { HotRegisterer } from 'angular-handsontable';
import { ToastrService } from 'ngx-toastr';

import {Report} from '../shared/report.model';
import {ReportDataService} from '../report-data.service';
import { FlexFileError } from '../shared/errors/FlexFileError';

@Component({
  selector: 'app-error-modal',
  templateUrl: './error-modal.component.html',
  styleUrls: ['./error-modal.component.scss']
})
export class ErrorModalComponent implements OnInit {

  private error: FlexFileError;

  constructor(public bsModalRef: BsModalRef, private reportService: ReportDataService) { }

  ngOnInit() {
    this.error = this.reportService.currentError;
  }

  done() {
    this.bsModalRef.hide();
  }



}



// WEBPACK FOOTER //
// ./src/app/error-modal/error-modal.component.ts